import { render, staticRenderFns } from "./Transorderdb.vue?vue&type=template&id=0031e4ea&scoped=true"
import script from "./Transorderdb.vue?vue&type=script&lang=js"
export * from "./Transorderdb.vue?vue&type=script&lang=js"
import style0 from "./Transorderdb.vue?vue&type=style&index=0&id=0031e4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0031e4ea",
  null
  
)

export default component.exports